import type { FC, ReactNode } from "react";

type BackgroundProps = {
  /**
   * Картинка по умолчанию или значение фона (градиент, изображение, цвет).
   */
  bgValue: string;
  /**
   * Картинка или значение фона для таблетных устройств и выше.
   */
  mdBgValue?: string;
  /**
   * Картинка или значение фона для десктопных устройств.
   */
  dBgValue?: string;
  className?: string;
  children: ReactNode;
};

const isGradient = (value: string): boolean => value.includes("gradient(");

const isImage = (value: string): boolean => {
  return (
    /\.(jpe?g|png|gif|webp|avif|svg|bmp|ico|tiff?)$/i.test(value) ||
    /^(https?:\/\/)/.test(value)
  );
};

const formatBackgroundValue = (value: string): string => {
  if (!value) return "";

  if (isImage(value)) {
    return `url(${value})`;
  }

  return value;
};

const backgroundClass = (value: string, breakpoint?: "md" | "lg"): string => {
  if (!value) return "";

  if ((isImage(value) || isGradient(value)) && !breakpoint) {
    return "bg-value";
  }

  if ((isImage(value) || isGradient(value)) && breakpoint === "md") {
    return "md:bg-mdValue";
  }

  if ((isImage(value) || isGradient(value)) && breakpoint === "lg") {
    return "lg:bg-dValue";
  }

  if (breakpoint === "md") {
    return "md:bg-color-mdValue";
  }

  if (breakpoint === "lg") {
    return "lg:bg-color-dValue";
  }

  return "bg-color-value";
};
export const Background: FC<BackgroundProps> = ({
  bgValue,
  mdBgValue,
  dBgValue,
  className,
  children,
}) => {
  return (
    <div
      style={{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        "--bgValue": formatBackgroundValue(bgValue),
        "--mdBgValue": formatBackgroundValue(mdBgValue ?? bgValue),
        "--dBgValue": formatBackgroundValue(dBgValue ?? mdBgValue ?? bgValue),
      }}
      className={`w-full bg-cover bg-center ${backgroundClass(bgValue)} ${backgroundClass(mdBgValue ?? bgValue, "md")} ${backgroundClass(dBgValue ?? mdBgValue ?? bgValue, "lg")} ${className}`}
    >
      {children}
    </div>
  );
};
